import { mainApi } from "services/main";
import {
  CreateGaiaObjectResponse,
  UpdateGaiaObjectRequest,
} from "./definitions";
import { GaiaObject } from "models/generateGaiaObjSchemas";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createGaiaObject: builder.mutation<CreateGaiaObjectResponse, GaiaObject>({
      query: (request: GaiaObject) => ({
        url: "gaia-objects",
        body: request,
        method: "POST",
      }),
    }),
    updateGaiaObject: builder.mutation<GaiaObject, UpdateGaiaObjectRequest>({
      query: (request: UpdateGaiaObjectRequest) => ({
        url: `gaia-objects/${request.gaiaObjectId}`,
        body: {
          gaiaObjectId: request.gaiaObjectId,
          gaiaObject: request.gaiaObject,
        },
        method: "PUT",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateGaiaObjectMutation,
  useUpdateGaiaObjectMutation,
  usePrefetch,
} = extendedApi;
